const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 50,
  },
  {
    prop: "CountryMan",
    label: "全国总监",
    columnwidth: 120,
  },
  {
    prop: "RegionMan",
    label: "大区经理",
    columnwidth: 150,
  },
  {
    prop: "AreaMan",
    label: "地区经理",
    columnwidth: 150,
  },
  {
    prop: "TrueName",
    label: "销售人员",
    columnwidth: 180,
  },
  {
    prop: "Province",
    label: "省份",
    columnwidth: 120,
  },
  {
    prop: "City",
    label: "城市",
    columnwidth: 120,
  },
  {
    prop: "HPCode",
    label: "医院编码",
    columnwidth: 120,
  },
  {
    prop: "HPName",
    label: "医院名称",
    columnwidth: 165,
  },
  {
    prop: "UserName",
    label: "业务员账号",
    columnwidth: 165,
  },
  {
    prop: "TrueName",
    label: "业务员",
    columnwidth: 165,
  },
  {
    prop: "PTAProName",
    label: "PTA球囊入院进度",
    columnwidth: 150,
  },
  {
    prop: "HPProName",
    label: "HP球囊入院进度",
    columnwidth: 150,
  },
  {
    prop: "DCBProName",
    label: "DCB入院进度",
    columnwidth: 150,
  },
  {
    prop: "GCProName",
    label: "回收器械入院状态",
    columnwidth: 150,
  },
]
export default headerData
